// import "@/App.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { Toaster } from "sonner";
// import Dashboard from "@/pages/Dashboard";
// import Subjects from "@/pages/Subjects";
// import Topics from "@/pages/Topics";
// import Questions from "@/pages/Questions";
// import ExamsPage from "./pages/ExamsPage";
// import ExamQuestionsPage from "./pages/ExamQuestionsPage";
// import UserManagement from "./pages/UserManagement";
// import Login from "./Login";

// function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Dashboard />} />
//           <Route path="/subjects" element={<Subjects />} />
//           <Route path="/subjects/:subjectId/topics" element={<Topics />} />
//           <Route path="/topics" element={<Topics />} />
//           <Route path="/exams" element={<ExamsPage />} />
//           <Route path="/exams/:examId/questions" element={<ExamQuestionsPage />} />
//           <Route path="/topics/:topicId/questions" element={<Questions />} />
//           <Route path="/questions" element={<Questions />} />
//            <Route path="/users" element={<UserManagement />} />
//            <Route path="/login" element={<Login />} />
//         </Routes>
//       </BrowserRouter>
//       <Toaster position="top-right" richColors />
//     </div>
//   );
// }

// export default App;


import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Dashboard from "@/pages/Dashboard";
import Subjects from "@/pages/Subjects";
import Topics from "@/pages/Topics";
import Questions from "@/pages/Questions";
import ExamsPage from "./pages/ExamsPage";
import ExamQuestionsPage from "./pages/ExamQuestionsPage";
import UserManagement from "./pages/UserManagement";
import Login from "@/Login";

import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>

          {/* 🔓 Public route */}
          <Route path="/login" element={<Login />} />

          {/* 🔐 Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/subjects"
            element={
              <ProtectedRoute>
                <Subjects />
              </ProtectedRoute>
            }
          />

          <Route
            path="/subjects/:subjectId/topics"
            element={
              <ProtectedRoute>
                <Topics />
              </ProtectedRoute>
            }
          />

          <Route
            path="/topics"
            element={
              <ProtectedRoute>
                <Topics />
              </ProtectedRoute>
            }
          />

          <Route
            path="/exams"
            element={
              <ProtectedRoute>
                <ExamsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/exams/:examId/questions"
            element={
              <ProtectedRoute>
                <ExamQuestionsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/topics/:topicId/questions"
            element={
              <ProtectedRoute>
                <Questions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/questions"
            element={
              <ProtectedRoute>
                <Questions />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />

        </Routes>
      </BrowserRouter>

      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;